import {pullRequestsAppBuilder} from '../config/app-builder'
import {mainQuery} from '@github-ui/react-core/future/main-query'
import type {ChangesRoutePayload, FilesRoutePayload} from './route-payload-types'

export const pullRequestsChangesRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsChangesRoute', {
  path: '/:owner/:repo/pull/:pr_number/changes',
  queries: [mainQuery<ChangesRoutePayload>()],
})

export const pullRequestsChangesWithRangeRoute = pullRequestsAppBuilder.createQueryRouteConfig(
  'pullRequestsChangesWithRangeRoute',
  {
    path: '/:owner/:repo/pull/:pr_number/changes/:range',
    queries: [mainQuery<ChangesRoutePayload>()],
  },
)

export const pullRequestsFilesRoute = pullRequestsAppBuilder.createQueryRouteConfig('pullRequestsFilesRoute', {
  path: '/:owner/:repo/pull/:pr_number/files',
  queries: [mainQuery<FilesRoutePayload>()],
})

export const pullRequestsFilesWithRangeRoute = pullRequestsAppBuilder.createQueryRouteConfig(
  'pullRequestsFilesWithRangeRoute',
  {
    path: '/:owner/:repo/pull/:pr_number/files/:range',
    queries: [mainQuery<FilesRoutePayload>()],
  },
)
